export default __webpack_public_path__ + "static/iconography-image-m-1850acea5bf18e0d5acec68c77055bfacc6f396369f6041335d1d3abd0c58336.png";